
export type ProgressMarker = "low" | "med" | "high";
export type ProgressMarker2 = { type: "ProgressMarker2";
                                score: ProgressMarker;
                                info: string;
                                keyPoints: string;
                                related: string;
                                geoMatcher: (feature: any) => boolean| undefined;
                              }

export type ProgressMarkerMerge = ProgressMarker|ProgressMarker2
type ProgressMap = Map<string, ProgressMarkerMerge>

function progressGen() {
  const map = new Map<string, ProgressMarkerMerge>();

  map.set("USA", {
    type: "ProgressMarker2",
    score: "high",
    info: "The United States has high cryptocurrency adoption, driven by institutional investments, regulatory developments, and a vibrant crypto startup ecosystem.",
    keyPoints: "Institutional adoption, strong innovation, high trading volumes",
    related: "Key companies include Coinbase, Binance.US, and Kraken",
    geoMatcher: (feature: any) => {
      if (feature.properties.ISO_A3 === "USA") { return true }
    }
  })

  map.set("CAN", "med");
  map.set("MEX", "low");
  map.set("BRA", "med");
  map.set("ARG", "med");
  map.set("VEN", "high");
  map.set("COL", "med");
  map.set("CHL", "low");
  map.set("PER", "low");
  map.set("GBR", "med");
  map.set("FRA", "med");
  map.set("DEU", "med");
  map.set("ESP", "med");
  map.set("ITA", "low");
  map.set("NLD", "med");
  map.set("CHE", "med");
  map.set("RUS", "high");
  map.set("UKR", "high");
  map.set("TUR", "high");
  map.set("IND", "high");
  map.set("CHN", "low");
  map.set("JPN", "med");
  map.set("KOR", "med");
  map.set("PHL", "high");
  map.set("VNM", "high");
  map.set("THA", "med");
  map.set("IDN", "med");
  map.set("AUS", "med");
  map.set("NZL", "low");
  map.set("ZAF", "med");
  map.set("NGA", "high");
  map.set("KEN", "high");
  map.set("EGY", "med");
  map.set("ETH", "med");
  map.set("SAU", "low");
  map.set("ARE", "med");
  map.set("ISR", "med");

  return map
}

const progress = progressGen()

export { progress }